















































import { IPriceCategory } from '@/interfaces';
  import { Component, Vue } from 'vue-property-decorator';
  import { AjaxHelper } from '@/AjaxHelper';

  import List from '@/components/List.vue';
  import ListItem from '@/components/ListItem.vue';
  import Btn from '@/components/Btn.vue';
  import Field from '@/components/Field.vue';
  import TextField from '@/components/TextField.vue';

  @Component({
    name: 'admin-price-categories-page',
    components: { List, ListItem, Btn, Field, TextField },
    beforeRouteEnter: async (to, from, next) => {
      const categories = await AjaxHelper.get('/pricecategory');
      next(vm => {
        (vm as any).categories = categories;
      });
    }
  })
  export default class AdminPriceCategoriesComponent extends Vue {
    public categories: IPriceCategory[] = [];
    public searchText = '';

    public get filteredCategories(): IPriceCategory[] { return this.searchText.length > 0 ? this.categories.filter(x => x.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) : this.categories; }
  }
